import { h, Fragment } from 'preact';
import Media from 'utils/media';
import useResponsive from 'utils/responsive';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useMemo, useRef, useState } from 'preact/hooks';
import useInView from 'utils/in-view';
import ProductBadge from './product-badge';

const ProductCardMedia = ({ product, placement, imageSlider = false }) => {
  const { breakPoint } = useResponsive();
  const [visible, setVisible] = useState(false);
  const [containerRef, inView, disconnect] = useInView({ rootMargin: '100px' });
  const [currentSlide, setCurrentSlide] = useState(null);

  if (
    imageSlider &&
    !['lg', 'tablet'].includes(breakPoint) &&
    product.media.length > 1
  ) {
    const slider = useRef(null);

    const paginationConfig = useMemo(
      () => ({
        clickable: false,
        horizontalClass: '!flex gap-2 items-center px-5',
        bulletClass: 'flex-1 bg-grey-600',
        bulletActiveClass: '!bg-black',
      }),
      [],
    );

    useEffect(() => {
      if (slider.current?.activeIndex > product.media.length) {
        slider.current.slideTo(product.media.length, 0);
      }
    }, [product]);

    useEffect(() => {
      if (inView) {
        setVisible(true);
        disconnect();
      }
    }, [inView]);

    return (
      <Swiper
        modules={[Pagination]}
        loop={true}
        ref={containerRef}
        pagination={paginationConfig}
        className="!absolute inset-0"
        onInit={(swiper) => {
          slider.current = swiper;
        }}
        onSlideChange={(state) => {
          setCurrentSlide(state.activeIndex - 1);
        }}
      >
        {product.media.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div key={item.id} className="relative h-full w-full">
              {placement !== 'cart' && index === 0 && (
                <ProductBadge
                  containerClassName="absolute z-20 left-0 bottom-8 lg:bottom-16 lc:min-h-[34px] ml:min-h-[24px] flex items-center max-w-[calc(100%-90px)]"
                  badges={product.badges?.value}
                />
              )}
              <Media
                {...item}
                className="absolute inset-0 object-cover h-full w-full"
                controlClass="!hidden "
                lazyLoad={!visible}
                slideId={index}
                currentSlide={currentSlide}
                srcWidths={{
                  sm: 640,
                  md: 768,
                  lg: 1024,
                  xl: 1280,
                  '2xl': 1536,
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  }

  return (
    <>
      {product.media?.[0] && (
        <span className="absolute inset-0 [&_div]:h-full">
          <Media
            {...product.media[0]}
            srcWidths={{ sm: 640 }}
            className="object-cover h-full w-full"
            controlClass="!hidden"
            lazyLoad={!visible}
          />
        </span>
      )}
      {product.media?.[1] && (
        <span className="absolute z-20 inset-0 invisible group-hover/media:desktophover:visible  [&_div]:h-full">
          <Media
            {...product.media[1]}
            srcWidths={{ sm: 640 }}
            className="object-cover h-full w-full"
            controlClass="!hidden "
            lazyLoad={!visible}
          />
        </span>
      )}
    </>
  );
};

export default ProductCardMedia;
